import React from "react";

import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  tableCellRoot: {
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 12,
    paddingBottom: 12,
    fontSize: 16,
    letterSpacing: 0.4,
    color: theme.palette.common.dark,
    fontWeight: theme.typography.bold,
    borderBottom: "0 none",
    "&:first-child": {
      paddingLeft: 24,
    },
  },
}));

const PointsBankTableHeading = () => {
  const classes = useStyles();
  return (
    <TableRow>
      <TableCell className={classes.tableCellRoot}>کد پرسنلی</TableCell>
      <TableCell className={classes.tableCellRoot}>امتیاز</TableCell>
      <TableCell className={classes.tableCellRoot}>تاریخ اولین واریز</TableCell>
      <TableCell className={classes.tableCellRoot}>تاریخ تغییر</TableCell>
    </TableRow>
  );
};

export default PointsBankTableHeading;